import { Box, Flex, Stack, Text } from '@chakra-ui/react'
import dayjs from 'dayjs'
import { getFullName } from 'src/utils/getFullName'

import { WorksheetLog } from '../../types'

type Props = {
  sendLog?: WorksheetLog
  acceptLog?: WorksheetLog
}

export const PrintFooter: React.FC<Props> = ({ sendLog, acceptLog }) => {
  return (
    <Box mt="8" className="print-footer">
      <Stack spacing="0">
        {sendLog && (
          <Flex justify="flex-end">
            <Text color="gray.600" fontSize="lg">
              指示確定：{' '}
              {sendLog.trialHospitalName && `${sendLog.trialHospitalName} `}
              {getFullName(sendLog.trialMember)}（
              {dayjs(sendLog.savedAt).format('YYYY年MM月DD日')}）
            </Text>
          </Flex>
        )}
        {acceptLog && (
          <Flex justify="flex-end">
            <Text color="gray.600" fontSize="lg">
              受領：{' '}
              {acceptLog.trialHospitalName && `${acceptLog.trialHospitalName} `}
              {getFullName(acceptLog.trialMember)}（
              {dayjs(acceptLog.savedAt).format('YYYY年MM月DD日')}）
            </Text>
          </Flex>
        )}
      </Stack>
    </Box>
  )
}
